module.exports = __webpack_public_path__ + "fonts/Inter-700-cyrillic65.de93fdc.woff2";